export const PROJECT = "PROJECT";
export const PROJECT_SUCCESS = "PROJECT_SUCCESS";
export const PROJECT_FAILED = "PROJECT_FAILED";

export const FILTERED_PROJECT = "FILTERED_PROJECT";
export const FILTERED_PROJECT_SUCCESS = "FILTERED_PROJECT_SUCCESS";
export const FILTERED_PROJECT_FAILED = "FILTERED_PROJECT_FAILED";

export const ADD_PROJECT = "ADD_PROJECT";
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS";
export const ADD_PROJECT_FAILED = "ADD_PROJECT_FAILED";

export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS";
export const UPDATE_PROJECT_FAILED = "UPDATE_PROJECT_FAILED";

export const PROJECT_CATEGORY = "PROJECT_CATEGORY";
export const PROJECT_CATEGORY_SUCCESS = "PROJECT_CATEGORY_SUCCESS";
export const PROJECT_CATEGORY_FAILED = "PROJECT_CATEGORY_FAILED";

export const ADD_PROJECT_CATEGORY = "ADD_PROJECT_CATEGORY";
export const ADD_PROJECT_CATEGORY_SUCCESS = "ADD_PROJECT_CATEGORY_SUCCESS";
export const ADD_PROJECT_CATEGORY_FAILED = "ADD_PROJECT_CATEGORY_FAILED";

export const DELETE_PROJECT_CATEGORY = "DELETE_PROJECT_CATEGORY";
export const DELETE_PROJECT_CATEGORY_SUCCESS = "DELETE_PROJECT_CATEGORY_SUCCESS";
export const DELETE_PROJECT_CATEGORY_FAILED = "DELETE_PROJECT_CATEGORY_FAILED";

export const PROJECT_LABEL = "PROJECT_LABEL";
export const PROJECT_LABEL_SUCCESS = "PROJECT_LABEL_SUCCESS";
export const PROJECT_LABEL_FAILED = "PROJECT_LABEL_FAILED";

export const ADD_PROJECT_LABEL = "ADD_PROJECT_LABEL";
export const ADD_PROJECT_LABEL_SUCCESS = "ADD_PROJECT_LABEL_SUCCESS";
export const ADD_PROJECT_LABEL_FAILED = "ADD_PROJECT_LABEL_FAILED";

export const DELETE_PROJECT_LABEL = "DELETE_PROJECT_LABEL";
export const DELETE_PROJECT_LABEL_SUCCESS = "DELETE_PROJECT_LABEL_SUCCESS";
export const DELETE_PROJECT_LABEL_FAILED = "DELETE_PROJECT_LABEL_FAILED";

export const PROJECT_STATUS = "PROJECT_STATUS";
export const PROJECT_STATUS_SUCCESS = "PROJECT_STATUS_SUCCESS";
export const PROJECT_STATUS_FAILED = "PROJECT_STATUS_FAILED";

export const ADD_PROJECT_STATUS = "ADD_PROJECT_STATUS";
export const ADD_PROJECT_STATUS_SUCCESS = "ADD_PROJECT_STATUS_SUCCESS";
export const ADD_PROJECT_STATUS_FAILED = "ADD_PROJECT_STATUS_FAILED";

export const PROJECT_FILES = "PROJECT_FILES";
export const PROJECT_FILES_SUCCESS = "PROJECT_FILES_SUCCESS";
export const PROJECT_FILES_FAILED = "PROJECT_FILES_FAILED";

export const ADD_PROJECT_FILES = "ADD_PROJECT_FILES";
export const ADD_PROJECT_FILES_SUCCESS = "ADD_PROJECT_FILES_SUCCESS";
export const ADD_PROJECT_FILES_FAILED = "ADD_PROJECT_FILES_FAILED";

export const PROJECT_MILESTONES = "PROJECT_MILESTONES";
export const PROJECT_MILESTONES_SUCCESS = "PROJECT_MILESTONES_SUCCESS";
export const PROJECT_MILESTONES_FAILED = "PROJECT_MILESTONES_FAILED";

export const ADD_PROJECT_MILESTONES = "ADD_PROJECT_MILESTONES";
export const ADD_PROJECT_MILESTONES_SUCCESS = "ADD_PROJECT_MILESTONES_SUCCESS";
export const ADD_PROJECT_MILESTONES_FAILED = "ADD_PROJECT_MILESTONES_FAILED";

export const UPDATE_PROJECT_MILESTONES = "UPDATE_PROJECT_MILESTONES";
export const UPDATE_PROJECT_MILESTONES_SUCCESS = "UPDATE_PROJECT_MILESTONES_SUCCESS";
export const UPDATE_PROJECT_MILESTONES_FAILED = "UPDATE_PROJECT_MILESTONES_FAILED";

export const DELETE_PROJECT_MILESTONES = "DELETE_PROJECT_MILESTONES";
export const DELETE_PROJECT_MILESTONES_SUCCESS = "DELETE_PROJECT_MILESTONES_SUCCESS";
export const DELETE_PROJECT_MILESTONES_FAILED = "DELETE_PROJECT_MILESTONES_FAILED";

export const CLEAR_ADD_PROJECT_MILESTONES = "CLEAR_ADD_PROJECT_MILESTONES";